import { Component, EventEmitter } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { DateInputComponent } from 'components/input/date-input/date-input.component';
import { ReasonSelectComponent } from 'components/input/reason-select/reason-select.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { ReasonType } from 'enums/ReasonType';
import { InvoiceObjectionModel } from 'models/generated/Entities.Accounting.InvoiceObjection';
import { ReasonModel } from 'models/generated/Entities.GormCrm.Reason';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { InvoicingService } from 'services/invoicing.service';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { ReasonService } from 'services/reason.service';

@CredentialRequired(CredentialType.CreateInvoiceObjection)
@Component({
	templateUrl: './create-invoice-objection.component.html',
	providers: [FormValidationService],
	imports: [Layout, ReasonSelectComponent, CustomInputComponent, DateInputComponent, TranslatePipe]
})
export class CreateInvoiceObjectionComponent {
	documentNo?: string;
	brandId?: string;
	objection: InvoiceObjectionModel = new InvoiceObjectionModel();
	today = new Date();
	inputType = InputType;
	reasonType = ReasonType;
	reasons?: ReasonModel[];
	loading = true;

	objectionSaved = new EventEmitter<InvoiceObjectionModel>();

	constructor(private readonly invoicingService: InvoicingService,
		private readonly navigationService: NavigationService,
		private readonly reasonService: ReasonService) { 
			this.reasonService.getAllReasons().then(reasons => {
				this.reasons = reasons;
				this.loading = false;
			});
		}

	createOrUpdate() {
		if (this.loading || !this.documentNo || !this.brandId) return;
		this.objection.documentNo = this.documentNo;
		this.objection.brandId = this.brandId;
		const setInvoiceOnHold = this.reasonSetsOnHold(this.objection.reasonId!);
		this.invoicingService.createOrUpdateInvoiceObjection(this.objection, setInvoiceOnHold).then(objection => {
			this.objectionSaved.emit(objection);
			this.navigationService.closeView(this);
		});
	}

	reasonSetsOnHold(reasonId: string): boolean {
		const reason = this.reasons!.find(r => r.id == reasonId);
		if (!reason || !reason.onHoldTypes) return false;

		return (reason.onHoldTypes & ReasonType.Objection) > 0;
	}
}
